import history from "@/util/history"
import { redirectToLogin } from "@/util/url"
import React from "react"

export const TopScreen = () => {
	// eslint-disable-next-line react-hooks/exhaustive-deps
	React.useEffect(() => {
		if (localStorage.getItem("email")) {
			history.push("/tables")
		} else {
			location.href = redirectToLogin("/tables")
		}
	}, [])

	return <></>
}
